<template>
  <footer class="site-footer">
    <div class="container site-footer__grid">
      <div>
        <router-link class="site-logo" to="/">
          <img v-if="logoUrl" :src="logoUrl" :alt="settings.siteName || 'STRONGOVA'">
          <span v-else>{{ settings.siteName || 'STRONGOVA' }}</span>
        </router-link>
        <h4>{{ $t('nav.contact') }}</h4>
        <p>China: {{ settings.factoryAddressCn }}</p>
        <!-- <p>Serbia: {{ settings.factoryAddressRs }}</p> -->
        <p>{{ $t('common.phone') }}: {{ settings.contactPhone }}</p>
        <p>{{ $t('common.email') }}: {{ settings.contactEmail }}</p>
      </div>
      <div>
        <h4>Favorite</h4>
        <ul>
          <li v-for="item in site.footer.favorites" :key="item.label">
            <router-link :to="item.href">{{ displayFooterLabel(item) }}</router-link>
          </li>
        </ul>
      </div>
      <div class="site-footer__social-column">
        <h4>Social media</h4>
        <div class="site-footer__social-body">
          <ul class="site-footer__socials">
            <li v-for="item in visibleSocialItems" :key="item.label">
              <a
                :href="item.href"
                target="_blank"
                rel="noopener noreferrer"
                :aria-label="item.label"
                :title="item.label"
              >
                <img class="site-footer__social-icon" :src="item.icon" :alt="item.label" width="24" height="24" loading="lazy">
              </a>
            </li>
          </ul>
          <a
            v-if="whatsappHref"
            class="site-footer__whatsapp-qr"
            :href="whatsappHref"
            target="_blank"
            rel="noopener noreferrer"
            :aria-label="$t('common.whatsapp')"
          >
            <img src="/assets/social/whatsapp-qr.png" :alt="$t('common.whatsapp')" width="112" height="112" loading="lazy">
          </a>
        </div>
      </div>
    </div>
    <div class="container site-footer__bottom">
      <span>{{ settings.footerDesignedBy || 'Designed By:SENJU' }}</span>
      <span>{{ settings.footerText }}</span>
    </div>
  </footer>
</template>

<script>
import { resolveAssetUrl } from '../api/public'

export default {
  name: 'SiteFooter',
  props: {
    site: {
      type: Object,
      required: true
    }
  },
  computed: {
    settings () {
      return this.site.siteSettings || {
        siteName: 'STRONGOVA',
        footerText: 'CopyRight © 2005-2025 STRONGOVA .All right reserved',
        footerDesignedBy: 'Designed By:SENJU',
        contactEmail: 'STRONGOVA@strongova.com',
        contactPhone: '+86 15668650333',
        factoryAddressCn: 'NO.59 HAIXiang Road, Daweijia Street, Jinzhou District, Dalian City.',
        factoryAddressRs: 'Obrenovacki Put 237a, Baric'
      }
    },
    logoUrl () {
      return this.settings.logoImage ? resolveAssetUrl(this.settings.logoImage) : ''
    },
    whatsappHref () {
      const settings = this.settings
      const url = settings.socialWhatsapp || settings.socialYoutube
      return url ? String(url).trim() : ''
    },
    socialItems () {
      const settings = this.settings
      return [
        { label: 'WhatsApp', href: this.whatsappHref, icon: '/assets/social/whatsapp.png' },
        { label: 'Instagram', href: settings.socialInstagram, icon: '/assets/social/instagram.png' },
        { label: 'TikTok', href: settings.socialTiktok, icon: '/assets/social/tiktok.png' },
        { label: 'Facebook', href: settings.socialFacebook, icon: '/assets/social/facebook.png' },
        { label: 'LinkedIn', href: settings.socialLinkedin, icon: '/assets/social/linkedin.png' },
        { label: 'X', href: settings.socialX, icon: '/assets/social/x.png' }
      ]
    },
    visibleSocialItems () {
      return this.socialItems.filter(item => item.href)
    }
  },
  methods: {
    displayFooterLabel (item) {
      const keyMap = {
        Products: 'nav.products',
        Strength: 'nav.strength',
        Knowledge: 'nav.knowledge',
        Contact: 'nav.contact',
        'Privacy Policy': 'footer.privacyPolicy'
      }
      return keyMap[item.label] ? this.$t(keyMap[item.label]) : item.label
    }
  }
}
</script>

<style>
.site-footer {
  padding: 72px 0 30px;
  background: #111110;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
}

.site-footer__grid {
  display: grid;
  grid-template-columns: 1.35fr 0.9fr minmax(220px, 1.15fr);
  gap: 48px;
}

.site-footer__social-column {
  min-width: 0;
}

.site-footer .site-logo {
  display: inline-block;
  margin-bottom: 28px;
}

.site-footer .site-logo img {
  display: block;
  width: auto;
  height: 30px;
  max-width: 170px;
  object-fit: contain;
}

.site-footer h4 {
  margin: 0 0 16px;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(245, 243, 239, 0.9);
}

.site-footer p,
.site-footer li,
.site-footer a {
  margin: 0 0 10px;
  list-style: none;
  color: rgba(245, 243, 239, 0.68);
  line-height: 1.75;
}

.site-footer ul {
  padding: 0;
  margin: 0;
}

.site-footer__social-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}

.site-footer__socials {
  display: grid;
  grid-template-columns: repeat(3, 44px);
  gap: 10px;
  width: 100%;
  max-width: 152px;
  padding: 0;
  margin: 0;
}

.site-footer__whatsapp-qr {
  flex-shrink: 0;
  display: block;
  padding: 8px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.site-footer__whatsapp-qr:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.28);
}

.site-footer__whatsapp-qr img {
  display: block;
  width: 112px;
  height: 112px;
  object-fit: contain;
}

.site-footer__socials li {
  margin: 0;
}

.site-footer__socials a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  transition: background 0.2s ease, transform 0.2s ease;
}

.site-footer__socials a:hover {
  background: rgba(255, 255, 255, 0.14);
  transform: translateY(-1px);
}

.site-footer__social-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: block;
  object-fit: contain;
}

.site-footer__bottom {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  margin-top: 52px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  font-size: 13px;
  color: rgba(245, 243, 239, 0.46);
}

@media (min-width: 900px) {
  .site-footer__social-body {
    flex-direction: row;
    align-items: flex-start;
    gap: 24px;
  }

  .site-footer__socials {
    max-width: none;
  }
}

@media (max-width: 1100px) {
  .site-footer__grid {
    grid-template-columns: 1fr;
    gap: 34px;
  }

  .site-footer__social-body {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 24px;
  }

  .site-footer__socials {
    max-width: none;
  }

  .site-footer__bottom {
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .site-footer {
    padding: 52px 0 24px;
  }

  .site-footer .site-logo {
    margin-bottom: 22px;
  }

  .site-footer h4 {
    margin-bottom: 12px;
  }

  .site-footer p,
  .site-footer li,
  .site-footer a {
    font-size: 14px;
    line-height: 1.65;
    overflow-wrap: anywhere;
  }

  .site-footer__social-body {
    flex-direction: column;
    gap: 18px;
  }

  .site-footer__socials {
    grid-template-columns: repeat(3, 44px);
    gap: 8px;
  }

  .site-footer__whatsapp-qr {
    align-self: flex-start;
    padding: 6px;
  }

  .site-footer__whatsapp-qr img {
    width: 104px;
    height: 104px;
  }

  .site-footer__bottom {
    gap: 10px;
    margin-top: 36px;
    padding-top: 18px;
    font-size: 12px;
    line-height: 1.6;
  }
}
</style>
